import SyncableModel from './SyncableModel';

export default class FarmShrimpPrice extends SyncableModel {
  static name = 'FarmShrimpPrice'

  _fillable = [
    "id",
    "farm_id",
    "shrimp_price_id",
    "created_at", "updated_at",
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    farm_id: 'integer',
    shrimp_price_id: 'integer'
  }

  static endpoint = '/farm_shrimp_prices'

  static online = true
}
